class Sofatutor.Classes.DocumentInfo
  constructor: ->
    @$documentInfo     = $('.more-status-info')
    @$documentInfoLink = $('.js-show-document-info, .js-hide-document-info')
    @$hasEvent         = $._data(@$documentInfoLink[0], 'events')

    @bindEvent()

  bindEvent: ->
    unless @$hasEvent && @$hasEvent.click
      @$documentInfoLink.on 'click', => @$documentInfo.toggle()

$ ->
  return unless $('#teacher_account_request_job_confirmation, .teacher-account-request, .js-show-document-info')[0]
  new Sofatutor.Classes.DocumentInfo
